import { useSearchParams } from "react-router-dom";

export function usePagination<T>(items: readonly T[]) {
  const [search, setSearch] = useSearchParams();
  const requestedSize = Number(search.get("limit"));
  const pageSize = [25, 50, 100].includes(requestedSize) ? requestedSize : 25;
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const requestedPage = Number(search.get("page"));
  const page = Number.isSafeInteger(requestedPage)
    ? Math.min(pageCount, Math.max(1, requestedPage))
    : 1;
  const update = (key: string, value: number) => {
    const next = new URLSearchParams(search);
    next.delete("cursor");
    if (key === "limit") next.delete("page");
    next.set(key, String(value));
    setSearch(next);
  };
  return {
    items: items.slice((page - 1) * pageSize, page * pageSize),
    page,
    pageCount,
    pageSize,
    onPageChange: (value: number) => update("page", value),
    onPageSizeChange: (value: number) => update("limit", value),
  };
}
